import { UserNode } from './user-node';

export class Team {
    id: number;
    site: number;
    libelle: string;
    users: UserNode[];
    isPrincipal: boolean;
    teamAssignment: string;
    tlPeriods?: Array<{start: string, end: string}>
}



// WEBPACK FOOTER //
// ./src/app/model/team.ts